var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import classNames from 'classnames';
import SingleLineField from '../singleLineField/components/SingleLineField';
var HyperlinkField = /** @class */ (function (_super) {
    __extends(HyperlinkField, _super);
    function HyperlinkField(props) {
        var _this = _super.call(this, props) || this;
        _this.onBlur = _this.onBlur.bind(_this);
        _this.createAbsoluteExternalLink = _this.createAbsoluteExternalLink.bind(_this);
        _this.state = {
            hasExternalLink: !!_this.props.value,
        };
        return _this;
    }
    // Business logic is that external link icon is not updated until User clicks out of field
    HyperlinkField.prototype.onBlur = function () {
        this.setState({ hasExternalLink: !!this.props.value });
    };
    // If URL does not already start with "http://" or "https://" we must prepend it, otherwise it will be treated as relative url
    // eg. value of "www.mylink.com" should not open "localhost:8086/www.mylink.com" but rather "http://www.mylink.com"
    HyperlinkField.prototype.createAbsoluteExternalLink = function () {
        if (!this.props.value || this.props.value.startsWith('http://') || this.props.value.startsWith('https://')) {
            return this.props.value;
        }
        return 'http://' + this.props.value;
    };
    HyperlinkField.prototype.render = function () {
        var _this = this;
        var _a = this.props, inverted = _a.inverted, className = _a.className, tooltip = _a.tooltip, _b = _a.displayToolTips, displayToolTips = _b === void 0 ? true : _b, errorText = _a.errorText;
        var tooltipValue = tooltip ? tooltip
            : (displayToolTips && this.props.value ? { value: this.props.value } : undefined);
        var icon = this.state.hasExternalLink ? 'mui:OpenInNew' : 'mui:Link';
        var externalLink = this.createAbsoluteExternalLink();
        var iconAction = this.state.hasExternalLink ? function () { return window.open(externalLink, '_blank'); } : undefined;
        return (React.createElement("div", { className: classNames('HyperlinkField', { inverted: inverted }, className) },
            React.createElement(SingleLineField, { type: "text", name: this.props.name, label: this.props.label, value: this.props.value, tooltip: tooltipValue, icon: icon, iconAction: iconAction, onChange: function (value) { return _this.props.onChange(value); }, onBlur: this.onBlur, inverted: inverted, disabled: this.props.disabled, style: this.props.style, errorMessage: errorText, coloring: this.props.coloring, inherited: this.props.inherited })));
    };
    return HyperlinkField;
}(React.Component));
export default HyperlinkField;
//# sourceMappingURL=HyperlinkField.js.map